import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  onClick(evt) {
    const {target: {id, checked}} = evt;
    this.dispatch("update", {detail: { name: id, value: checked }});
  }
}
